module.exports = __webpack_public_path__ + "img/3D展示.a5a6661e.jpg";